module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.value) + ":  User Comments")]), _vm._v(" "), _c('h3', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "id": "addAnnotationButton",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Add Comment"
    },
    on: {
      "click": _vm.addAnnotationButtonClick
    }
  }, [_vm._v("\n                    Add Comment\n                    "), _c('span', {
    staticClass: "glyphicon glyphicon-comment"
  })])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('table', {
    staticClass: "table table-striped table-condensed",
    attrs: {
      "id": "commentsTable",
      "width": "100%"
    }
  })])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d095576", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d095576"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/model-annotations-table/model-annotations-table.vue.html
// module id = 1103
// module chunks = 0